import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useToggle from '../../../hooks/useToggle';
import { useApprovePackageCancellationRequestMutation } from '../../../store/apis/finances/packageCancellations';
import { Button, Col, Form, Input, message, Modal, Row } from 'antd';

const ApprovePackageCancellationRequest = ({ id }) => {
  const [t] = useTranslation();
  const [isOpen, show, hide] = useToggle();

  const [
    approvePackageCancellationRequest,
    {
      isLoading,
      isFetching,
    }
  ] = useApprovePackageCancellationRequestMutation();

  const submitForm = useCallback(async (values) => {
    try {
      await approvePackageCancellationRequest({ id, body: values }).unwrap();
      message.success(t('В возврате одобрено'));
      hide();
    } catch (e) {
      console.log(JSON.stringify(e, 0, 2));
    }
  }, [hide, id, approvePackageCancellationRequest, t]);

  return (
    <>
      <Button
        type="primary"
        onClick={show}
        disabled={!id}
      >
        {t('Согласиться')}
      </Button>
      <Modal
        title={t('Согласиться на возврат')}
        open={isOpen}
        onCancel={hide}
        footer={false}
        destroyOnClose
      >
        <p>
          {t('Вы уверены что хотите согласиться на возврат средств студенту?')}
        </p>
        <Form
          name="approve_cancellation_package_request"
          onFinish={submitForm}
          layout="vertical"
          disabled={isLoading || isFetching}
        >
          <Form.Item label={t('Комментарий')} name="comment" required rules={[{ required: true }]}>
            <Input.TextArea />
          </Form.Item>
          <Row justify="end" gutter={16}>
            <Col>
              <Button onClick={hide}>
                {t('Закрыть окно')}
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoading || isFetching}
              >
                {t('Подтвердить')}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default ApprovePackageCancellationRequest;
